<template>
    <div>
        <v-card v-for="year_el,index in eval_years" :key="index" >
            <v-card-title style="cursor:pointer" @click="loadYear(year_el, index)">
                {{ year_el }}
            </v-card-title>
            <v-card-text v-if="selected_year == index" >
                <v-card-text v-for="predmet,index2 in evaluations.predmety" :key="index2" :style="striedajBackground(index2)">
                    <v-row style="margin:1px;cursor:pointer;" @click="selectSubject(year_el, predmet.id, index2)">
                        {{ predmet.nazov }}
                        <v-spacer />
                        {{ predmet.priem }} ({{ predmet.pocet }})                        
                    </v-row>                   
                    <v-card-text v-if="selected_subject == index2">
                        <v-row v-for="otazka,index3 in subject_datails.predmety" :key="index3" :style="striedajBackground(index2)">
                            {{ otazka.otazka }}
                            <v-spacer />
                            {{ otazka.priem }} ({{ otazka.pocet }})
                            <v-card-text v-if="otazka.komentare" style="color:black;background-color:#E8F5E9;width:100%">- {{otazka.komentare}}</v-card-text>                            
                        </v-row>
                        <v-row style="margin:10px" />
                        <v-row v-for="otazka,index3 in subject_datails.vyucujuci" :key="index3" :style="striedajBackground(index2)">
                            {{ otazka.priezvisko }} ({{ otazka.typ }}) -
                            {{ otazka.otazka }}
                            <v-spacer />
                            {{ otazka.priem }} ({{ otazka.pocet }})
                            <v-card-text v-if="otazka.komentare" style="color:black;background-color:#E8F5E9;width:100%">- {{otazka.komentare}}</v-card-text>                            
                        </v-row>

                    </v-card-text>
                </v-card-text>
                

            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            eval_years: [],
            evaluations: [],
            subject_datails: [],
            selected_year: -1,
            selected_subject: -1,
            user_type: ''
        }
    },
    components: {
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)
            this.getYears()
        },
        striedajBackground(index3) {
           return index3 %2==1   ? 'background-color:#FFFFFF' : 'color:white;background-color:#2E7D32'
        },
        getYears() {
            axios.get('/get-evaluation-evaluated-years', this.$store.getters.getAxiosConfig)
            .then(res => {
                this.eval_years = res.data.year  
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        loadYear(_year_el, _index) {
            const _data = {
                obdobie: _year_el
            }
            this.selected_subject = -1
            axios.post('/get-evaluation-evaluations', _data, this.$store.getters.getAxiosConfig)
            .then(res => {
                this.evaluations = res.data                  
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
                this.selected_year = _index
                
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
        selectSubject(_year_el, _predmet_id, _index) {
            const _data = {
                obdobie: _year_el,
                predmet_id: _predmet_id
            }
            axios.post('/get-evaluation-subject', _data, this.$store.getters.getAxiosConfig)
            .then(res => {
                this.subject_datails = res.data  
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
                this.selected_subject = _index
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },        
    }
}
</script>

